export default "__VITE_ASSET__CsR4sU2i__"